import React from 'react';
import { FiClock, FiMail, FiMapPin, FiPhone } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

const ContactInfo = () => {
  const { t } = useTranslation();

  return (
    <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
      {[
        { label: t('support.contact.info.addressLabel'), value: t('support.contact.info.addressValue'), icon: <FiMapPin className="h-5 w-5" /> },
        { label: t('support.contact.info.phoneLabel'), value: t('support.contact.info.phoneValue'), icon: <FiPhone className="h-5 w-5" /> },
        { label: t('support.contact.info.emailLabel'), value: t('support.contact.info.emailValue'), icon: <FiMail className="h-5 w-5" /> },
        { label: t('support.contact.info.hoursLabel'), value: t('support.contact.info.hoursValue'), icon: <FiClock className="h-5 w-5" /> }
      ].map((item) => (
        <div key={item.label} className="soft-panel p-5">
          <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-teal-50 text-teal-700">
            {item.icon}
          </div>
          <p className="mt-4 text-xs uppercase tracking-[0.2em] text-stone-500">{item.label}</p>
          <p className="mt-2 text-sm leading-7 text-slate-700">{item.value}</p>
        </div>
      ))}
    </div>
  );
};

export default ContactInfo;
